(function () {
  'use strict';

  if (window.wigglyContentPagesLoaded) return;
  window.wigglyContentPagesLoaded = true;

  function makeUniqueId(heading, usedIds) {
    const base = (heading.textContent || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'policy-section';
    let id = base;
    let index = 2;

    while (usedIds.has(id) || document.getElementById(id)) {
      id = `${base}-${index}`;
      index += 1;
    }

    usedIds.add(id);
    return id;
  }

  function buildPolicyNavigation(policyPage) {
    if (!policyPage || policyPage.dataset.policyReady === 'true') return;

    const container = policyPage.querySelector('.shopify-policy__container');
    const body = container?.querySelector('.shopify-policy__body');
    const article = body?.querySelector('.rte');
    const headings = article ? [...article.querySelectorAll('h2, h3')] : [];
    if (!container || !body || !article || headings.length < 2) return;

    policyPage.dataset.policyReady = 'true';
    const usedIds = new Set();
    headings.forEach(function (heading) {
      if (!heading.id) heading.id = makeUniqueId(heading, usedIds);
      else usedIds.add(heading.id);
    });

    const navigation = document.createElement('nav');
    navigation.className = 'policy-toc';
    navigation.setAttribute('aria-label', policyPage.dataset.tocLabel || 'On this page');

    const details = document.createElement('details');
    details.className = 'policy-toc__details';
    const summary = document.createElement('summary');
    summary.className = 'policy-toc__summary';
    summary.textContent = policyPage.dataset.tocLabel || 'On this page';

    const list = document.createElement('ol');
    list.className = 'policy-toc__list';
    headings.forEach(function (heading) {
      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.classList.add('policy-toc__item--nested');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 991.98px)').matches) details.open = false;
      });
      item.appendChild(link);
      list.appendChild(item);
    });

    details.append(summary, list);
    navigation.appendChild(details);

    const layout = document.createElement('div');
    layout.className = 'policy-reading-layout';
    body.before(layout);
    layout.append(navigation, body);

    const desktopQuery = window.matchMedia('(min-width: 992px)');
    const syncDetails = function (event) {
      if (event.matches) details.open = true;
    };
    syncDetails(desktopQuery);
    desktopQuery.addEventListener?.('change', syncDetails);

    article.querySelectorAll('table').forEach(function (table) {
      const wrapper = document.createElement('div');
      wrapper.className = 'policy-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', policyPage.dataset.tableLabel || 'Scrollable policy table');
      table.before(wrapper);
      wrapper.appendChild(table);
    });
  }

  function focusContactMessage(scope) {
    const message = scope.querySelector('.contact-form-message[role="alert"]');
    if (message) message.focus();
  }

  function initialise(scope) {
    const policyPage = scope.matches?.('[data-policy-page]') ? scope : scope.querySelector?.('[data-policy-page]');
    if (policyPage) buildPolicyNavigation(policyPage);
    focusContactMessage(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
